/// <reference path="../../_ext/Editors/ItemEditorDialog.ts" />
namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    export class SKUSplittingCommonDialog extends _Ext.ItemEditorDialog<SKUSplittingItemsRow> {
        protected getFormKey() { return SKUSplittingItemsForm.formKey; }
        protected getLocalTextPrefix() { return SKUSplittingItemsRow.localTextPrefix; }
        protected getDeletePermission() { return SKUSplittingItemsRow.deletePermission; }
        protected getInsertPermission() { return SKUSplittingItemsRow.insertPermission; }
        protected getUpdatePermission() { return SKUSplittingItemsRow.updatePermission; }

        public form = new SKUSplittingItemsForm(this.idPrefix);
        protected get_ExtDialogOptions() {
            let opt = super.get_ExtDialogOptions();
            opt.AutoFitContentArea = false;
            return opt;
        }


        constructor() {
            super();
            var Config = Q.deepClone(q.DefualtEditorOptions);
            Config.height = 150;
            q.initBOMEditor(this, this.form.BOMDetails, Config);
            q.initLaborEditor(this, this.form.LaborDetails, Config);
            q.showAndDisableField(this.form.StoneRate);
            q.showAndDisableField(this.form.LaborDetails);
            q.hideEditorToolbar(this.form.LaborDetails);
            q.hideField(this.form.BOMDetails)
            //Make grid full width
            q.HideCategoryLable(this.element);
            q.hideEditorLabel(this.form.BOMDetails);
            //Hide Image and BOM Details
            q.hideEditorLabel(this.form.BOMDetails);
            q.hideEditorLabel(this.form.ImageName);
            q.hideEditorToolbar(this.form.BOMDetails);
            q.setTextRightAlign(this.form.DiamondAmount);
            q.setTextRightAlign(this.form.DiamondPieces);
            q.setTextRightAlign(this.form.DiamondWeight);
            q.setTextRightAlign(this.form.OtherAmount);
            q.setTextRightAlign(this.form.OtherWeight);
            q.setTextRightAlign(this.form.OtherPieces);
            q.setTextRightAlign(this.form.StoneAmount);
            q.setTextRightAlign(this.form.StonePieces);
            q.setTextRightAlign(this.form.StoneWeight);
            q.setTextRightAlign(this.form.Pieces);
            q.setTextRightAlign(this.form.Weight);
            q.setTextRightAlign(this.form.NetAmount);
            q.setTextRightAlign(this.form.NetWeight);
            q.setTextRightAlign(this.form.UnitCost);
            q.setTextRightAlign(this.form.UnitLabour);
            q.setTextRightAlign(this.form.UnitRate);
            q.setTextRightAlign(this.form.GrossAmount);
            q.setTextRightAlign(this.form.StoneRate);

           
        }
        protected onDialogOpen() {
            super.onDialogOpen();
            //Cascade Code
            //let prior = $(".ui-dialog").eq(-2);
            //if (prior.length > 0) {
            //    $(document).one("dialogopen", (e) => {
            //        this.element.dialog().dialog('option', 'position', { my: 'left top', at: 'left+24 top+24', of: prior[0] });
            //    })
            //}

            if (this.entity.HasBom == false) {
                q.hideEditorTab(this.form.ImageName);
                q.showField(this.form.BOMDetails, false)

            }
        }
  
    }
}